module.exports = __webpack_public_path__ + "static/media/ai-agent.2c97e491.svg";